import { memo, useCallback } from "react";
import { View, Text, UniversalDatePicker } from "@src/components";
import { useStartDate, type GridStore } from "../grid-store";
import { useUnistyles } from "react-native-unistyles";

const StartDateLabel = memo(() => (
  <Text textStyle="sm/regular" color="textSecondary">
    Start date
  </Text>
));

const StartDateControl = memo<{ store: GridStore }>(({ store }) => {
  const value = useStartDate(store);
  const { theme } = useUnistyles();

  const handleChange = useCallback(
    (iso: string) => {
      store.getState().setStartDate(iso);
    },
    [store],
  );

  return (
    <View flex={1} style={{ maxWidth: 230 }}>
      <UniversalDatePicker
        value={value}
        onChange={handleChange}
        placeholder="Select start date"
        size="medium"
        dateFormat="d-MMMM-yyyy"
        minimumDate={new Date(2000, 0, 1)}
        maximumDate={new Date(2030, 0, 1)}
        containerFormInputStyle={{
          backgroundColor: theme.colors.surface1.background,
          borderColor: theme.colors.interactive.buttons.default_background,
          height: 40,
        }}
      />
    </View>
  );
});

export const StartDateSection = memo<{ store: GridStore }>(({ store }) => (
  <View flexDirection="row" gap="md" mb="2xl" alignItems="center" justifyContent="space-between">
    <StartDateLabel />
    <StartDateControl store={store} />
  </View>
));
